<template>
    <b-list-group-item :disabled="isDisabled" @click="goToNext()">
        <div class="list-title">
            <b-row>
                <b-col cols="12">
                    {{ model.controlCardNumber }}
                </b-col>
            </b-row>
        </div>
        <div>{{ model.receivingDate | moment('DD-MMM-YYYY') }}</div>
    </b-list-group-item>
</template>

<script>
export default {
    props: {
        model: {
            default: {},
            type: Object
        },
        isDisabled: {
            default: Boolean,
            type: false
        }
    },
    methods: {
        goToNext() {
            if (!this.isDisabled) {
                this.$emit('nextAction');
            }
        },
    },
    computed: {
        
    },
}
</script>